import { yup } from '@framework/validation';
import { WidgetType } from '../../widgets/Widget';
import { FieldDatatype } from '../datatype/Datatype';
import { IReference, ReferenceType } from '../references/IReference';
import { ReferencePathDirection } from '../references/IReferencePath';
import { VirtualReferenceType } from '../references/virtual/VirtualReferenceType';
import { ReferenceMetaKey } from './isReferenceSchema';

export const ReferenceSchema: yup.ObjectSchema<IReference, any, any, any> = yup
  .object({
    type: yup.string().oneOfEnum(ReferenceType).required(),
    // Non possiamo usare `oneOfEnum` perché non è possibile
    // registrare ulteriori tipi di widget
    widgetType: yup.string().notRequired() as yup.StringSchema<WidgetType>,
    path: yup
      .array(
        yup
          .object({
            direction: yup
              .string()
              .oneOfEnum(ReferencePathDirection)
              .required(),
            code: yup.string().required(),
          })
          .label('Percorso'),
      )
      .required(),
    id: yup.string().label('ID').required(),
    code: yup.string().label('Codice').required(),
    label: yup.string().label('Label').required(),
    // TODO tipizzare correttamente / transform dal context?
    field: yup
      .object()
      .label('Campo')
      .required() as yup.ObjectSchema<FieldDatatype>,
    virtualType: yup.string().oneOfEnum(VirtualReferenceType).notRequired(),
    group: yup.string().label('Gruppo').notRequired(),
  })
  .noUnknown()
  .meta({ [ReferenceMetaKey]: true })
  // Essendo una Reference un valore impostato esternamente (non è l'utente che seleziona
  // manualmente i campi qui sopra), non è possibile usare il default normale
  // che creebbe un oggetto vuoto. Per questo motivo imposto un default null
  .default(null);
